export default __webpack_public_path__ + "static/media/spinner.d3fbaf2b.gif";